import React from "react";
import { connect } from "react-redux";
import moment from "moment";
import { DateRangePicker } from "react-dates";
import Button from "../../components/common/button";
import * as actions from "../../containers/dashboard/actions";
import "./styles.css";
class ReportDownload extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: null,
      endDate: null,
      focusedInput: null,
    };
  }

  onDateRangeChange = ({ startDate, endDate }) =>
    this.setState({ startDate, endDate });

  onDateRangeFocus = (focusedInput) => this.setState({ focusedInput });

  rangeChecker = (day) => {
    const today = moment();
    const ninetyDaysAgo = moment().subtract(90, "days");
    return !day.isBetween(ninetyDaysAgo, today, null, "[]");
  };

  isDatesOutOfRange = () => {
    const { endDate, startDate } = this.state;
    return endDate.diff(startDate, "days") > 7;
  };

  onSearchClick = () => {
    const { endDate, startDate } = this.state;
    if (!startDate || !endDate) {
      alert("Kindly select the date range");
      return;
    }
    let query = {
      start_date: new moment(startDate).format("YYYY-MM-DD"),
      end_date: new moment(endDate).format("YYYY-MM-DD"),
    };
    if (!this.isDatesOutOfRange()) {
      this.props.downloadReport(query);
    } else {
      alert("Kindly select the date range of 7 days");
      this.setState({ startDate: null, endDate: null });
    }
    return;
  };

  render() {
    const { startDate, endDate } = this.state;
    const calendarMaxDate = moment();
    const calendarMinDate = moment().subtract(90, "days");
    return (
      <div className="db-border-bottom">
        <div className="card-title">Download Booking Report</div>
        <div className="reportDwn">
          <div className="date-picker">
            <DateRangePicker
              startDateId="start_date"
              endDateId="end_date"
              daySize={30}
              displayFormat="DD-MM-YYYY"
              isOutsideRange={this.rangeChecker}
              hideKeyboardShortcutsPanel={true}
              startDate={startDate}
              endDate={endDate}
              focusedInput={this.state.focusedInput}
              onDatesChange={this.onDateRangeChange}
              onFocusChange={this.onDateRangeFocus}
              minDate={calendarMinDate}
              maxDate={calendarMaxDate}
              startDatePlaceholderText="Booking start date"
              endDatePlaceholderText="Booking end date"
              minimumNights={0}
            />
          </div>
          <div className="search-button">
            <Button label="Download" onButtonClick={this.onSearchClick} />
          </div>
        </div>
        <div className="note-text">
          Note: Reports are only available for the past 90 days.
        </div>
      </div>
    );
  }
}

const mapStateToProps = (store) => ({

});

const mapDispatchToProps = (dispatch) => ({
  downloadReport: (query) => dispatch(actions.downloadReport(query)),
});

ReportDownload.propTypes = {};

export default connect(mapStateToProps, mapDispatchToProps)(ReportDownload);
